import { Menu } from '@mantine/core';
import { Icon, SymbolCodepoints } from '@uag/react-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Group = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, setIsGroupPanelOpen } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            setIsGroupPanelOpen: state.setIsGroupPanelOpen
        }))
    );

    const selectedInstanceIds = useMemo(() => Object.keys(articleInstanceSelections), [articleInstanceSelections]);

    return (
        <Menu.Item
            disabled={selectedInstanceIds.length < 2}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon={'stack_group' as SymbolCodepoints}
                />
            }
            rightSection={
                <ActionShortcutHint actionId={InputActionId.ArticleGroup} className="min-w-36" />
            }
            onClick={() => setIsGroupPanelOpen(true)}
        >
            {t('labelGroup')}
        </Menu.Item>
    );
};
